import axios from "axios";

import { logoutApi } from "component/Auth/authService";
import { history } from "helpers";
import endpoints from "./endpoints";

//axios Instance
export const axiosInstance = axios.create({
  // baseURL: process.env.REACT_APP_BASE_URL,
  headers: {},
});

//logout
export const logout = async () => {
  axiosInstance.defaults.headers.common["Authorization"] = "";
  await logoutApi();
};

export function validateHttp(str) {
  if (str.indexOf("http://") === 0 || str.indexOf("https://") === 0) {
    return true;
  }
  return false;
}

export const renderNoData = (val, type) => {
  if (val === null || val === undefined || val === "") {
    return "-";
  }

  if (!isNaN(val)) {
    const num = Number(val);
    return num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  return type === "string" ? "" : val;
};

export const renderMonth = (month) => {
  let months = {
    Jan: "January",
    Feb: "February",
    Mar: "March",
    Apr: "April",
    May: "May",
    Jun: "June",
    Jul: "July",
    Aug: "August",
    Sep: "September",
    Oct: "October",
    Nov: "November",
    Dec: "December",
  };
  return months[month.split("-")[1]];
};

export const renderMonthValue = (amount, index, monthNumber) => {
  if (index > monthNumber) {
    return "-";
  } else {
    return `Rs. ${amount}`;
  }
};
export const renderMonthValues = (amount) => {
  return amount !== undefined ? amount : "0.00";
};
export const getTableData = (tabKey) => {
  console.log("tabKey", tabKey);
  switch (tabKey) {
    case "skillNameMapping":
      return endpoints.skillName.getSkillName;
    case "agentMapping":
      return endpoints.crmAgent.getAgentList;
    case "campaignMapping":
      return endpoints.crmConfiguration.getEventList;
    case "zendeskGroupMapping":
      return endpoints.zendeskgroup.getGroupList;
    default:
      throw new Error("Invalid tab key");
  }
};

export const createElement = (tabKey) => {
  switch (tabKey) {
    case "skillNameMapping":
      return endpoints.skillName.createSkillName;
    case "agentMapping":
      return endpoints.crmAgent.createAgent;
    case "campaignMapping":
      return endpoints.crmConfiguration.createEventCamp;
    case "zendeskGroupMapping":
      return endpoints.zendeskgroup.createGroup;
    default:
      throw new Error("Invalid tab key");
  }
};

export const updateElement = (tabKey) => {
  switch (tabKey) {
    case "skillNameMapping":
      return endpoints.skillName.updateSkillName;
    case "agentMapping":
      return endpoints.crmAgent.updateAgent;
    case "campaignMapping":
      return endpoints.crmConfiguration.updateEventCamp;
    case "zendeskGroupMapping":
      return endpoints.zendeskgroup.updateGroup;
    default:
      throw new Error("Invalid tab key");
  }
};

export const deleteTableData = (tabKey) => {
  switch (tabKey) {
    case "skillNameMapping":
      return endpoints.skillName.deleteSkillName;
    case "agentMapping":
      return endpoints.crmAgent.deleteAgent;
    case "campaignMapping":
      return endpoints.crmConfiguration.deleteEventCamp;
    case "zendeskGroupMapping":
      return endpoints.zendeskgroup.deleteGroup;
    default:
      throw new Error("Invalid tab key");
  }
};
export const numberOptions = (start, length) =>
  Array.from({ length: length }, (_, i) => {
    const num = i + start;
    return { label: String(num), value: String(num) };
  });
  
   export const maskAadhaar = (aadhaarNumber, role) => {
  console.log(role,"45")
  if (role === "ALLACCESS" || !aadhaarNumber) return aadhaarNumber;
  const str = aadhaarNumber.toString().replace(/\D/g, "");
  if (str.length !== 12) return aadhaarNumber;
  return `XXXX-XXXX-${str.slice(-4)}`;
};
export const maskPAN = (panNumber, role) => {
  if (role === "ALLACCESS" || !panNumber) return panNumber;
  const str = panNumber.toUpperCase();
  if (str.length !== 10) return panNumber;
  return `${str.slice(0, 3)}XXXX${str.slice(-3)}`; // Example: ABCXXXX4F
};
export const maskSensitiveData = (fieldName, value, role) => {
  if (!value) return "N/A";

  // If user has all-access role, return value as-is
  if (role === "ALLACCESS") {
    return value;
  }

  // Aadhaar masking (keep last 4 digits)
  if (fieldName === "aadhaarNumber") {
    const digits = value.replace(/\D/g, "");
    if (digits.length === 12) {
      return `XXXX-XXXX-${digits.slice(-4)}`;
    }
    return "Invalid Aadhaar";
  }

  // PAN masking (hide first 5 characters)
  if (fieldName === "panNumber") {
    return value.replace(/^(.{5})/, "XXXXX");
  }

  // Default return if not Aadhaar or PAN
  return value;
};